import React from 'react'
import { useTranslation } from 'react-i18next'
import { Breadcrumbs, Crumb } from '@carsys/ui'
import {
  VehicleSalesGlobalizationDetailsURL,
  VehicleSalesGlobalizationURL,
  VehicleSalesInventoryDetailQuotationsURL,
  VehicleSalesInventoryDetailTransactionURL,
  VehicleSalesInventoryDetailURL,
  VehicleSalesInventoryDetailVehicleQuotationURL,
  VehicleSalesInventoryURL,
  VehicleSalesInvoicesDetailURL,
  VehicleSalesInvoicesURL,
  VehicleSalesOpenTransactionsDetailsURL,
  VehicleSalesOpenTransactionsURL,
  VehicleSalesQuotationsDetailURL,
  VehicleSalesQuotationsURL,
  VehicleSalesSupplierInvoiceURL
} from 'app/vehicleSales/RouteConstants'

export const VehicleSalesBreadCrumbs: React.FC<React.ComponentProps<typeof Breadcrumbs>> = ({ ...props }) => {
  const { t } = useTranslation()

  return (
    <Breadcrumbs {...props}>
      <Crumb
        data-testid='crumb-vehicle-sales-inventory'
        key='crumb-vehicle-sales-inventory'
        path={VehicleSalesInventoryURL}
        text={t('VehicleSales.Inventory')}
      />
      <Crumb
        data-testid='crumb-vehicle-sales-inventory-details'
        key='crumb-vehicle-sales-inventory-details'
        path={VehicleSalesInventoryDetailURL}
        text={t('VehicleSales.DetailsTitle')}
      />
      <Crumb
        data-testid='crumb-vehicle-sales-supplier-invoice'
        key='crumb-vehicle-sales-supplier-invoice'
        path={VehicleSalesSupplierInvoiceURL}
        text={t('VehicleSales.SupplierInvoiceTitle')}
      />
      <Crumb
        data-testid='crumb-vehicle-sales-inventory-detail-transaction-type'
        key='crumb-vehicle-sales-inventory-detail-transaction-type'
        exact
        path={VehicleSalesInventoryDetailTransactionURL}
        text={params => t(`VehicleSales.${params.TransactionType}`)}
      />
      <Crumb
        data-testid='crumb-vehicle-sales-open-transactions'
        key='crumb-vehicle-sales-open-transactions'
        path={VehicleSalesOpenTransactionsURL}
        text={t('VehicleSales.OpenTransactionsTitle')}
      />
      <Crumb
        data-testid='crumb-vehicle-sales-transaction-type'
        key='crumb-vehicle-sales-transaction-type'
        exact
        path={VehicleSalesOpenTransactionsDetailsURL}
        text={params => t(`VehicleSales.${params.TransactionType}`)}
      />
      <Crumb
        data-testid='crumb-vehicle-sales-globalization'
        key='crumb-vehicle-sales-globalization'
        path={VehicleSalesGlobalizationURL}
        text={t('VehicleSales.GlobalizationTitle')}
      />
      <Crumb
        data-testid='crumb-vehicle-sales-globalization-details-view'
        key='crumb-vehicle-sales-globalization-details-view'
        path={VehicleSalesGlobalizationDetailsURL}
        text={t('VehicleSales.GlobalizationDetailsTitle')}
      />
      <Crumb
        data-testid='crumb-vehicle-sales-invoices'
        key='crumb-vehicle-sales-invoices'
        path={VehicleSalesInvoicesURL}
        text={t('VehicleSales.Invoices')}
      />
      <Crumb
        data-testid='crumb-vehicle-sales-invoice-details-view'
        key='crumb-vehicle-sales-invoice-details-view'
        path={VehicleSalesInvoicesDetailURL}
        text={t('invoice.invoice')}
      />
      <Crumb data-testid='crumb-vehicle-sales-quotations' path={VehicleSalesQuotationsURL} text={t('VehicleSales.QuotationsListTitle')} />
      <Crumb
        data-testid='crumb-vehicle-sales-quotation-details-view'
        key='crumb-vehicle-sales-quotation-details-view'
        path={VehicleSalesQuotationsDetailURL}
        text={t('VehicleSales.QuotationTitle')}
      />
      <Crumb
        exact
        data-testid='crumb-vehicle-sales-quotations-per-vehicle'
        key='crumb-vehicle-sales-quotations-per-vehicle'
        path={VehicleSalesInventoryDetailQuotationsURL}
        text={t('VehicleSales.QuotationsListTitle')}
      />
      <Crumb
        data-testid='crumb-vehicle-sales-inventory-detail-quotation'
        key='crumb-vehicle-sales-inventory-detail-quotation'
        path={VehicleSalesInventoryDetailVehicleQuotationURL}
        text={t('VehicleSales.QuotationTitle')}
      />
    </Breadcrumbs>
  )
}

export default VehicleSalesBreadCrumbs
